import { Layout } from '@components/common'
import { Container, Heading2 } from '@components/ui'
import { Grid, Column } from '@components/common'
import SEO from '@components/common/SEO/SEO'

export default function TermsAndConditions() {
  return (
    <Container>
      {/* Using Grid to Add Top/Bottom Padding w/o Creating a New Component */}
      <Grid xsGutter={30}>
        <Column xs={12}>
          <Heading2>TSPoolSupply.com Internet Terms and Conditions</Heading2>
          <p>
            These Website Standard Terms and Conditions written on this webpage
            shall manage your use of our website, TS Pool Supply accessible at
            TSPoolSupply.com.
          </p>
          <p>
            TS Pool Supply maintains this site (the “Site”) for your personal
            information, education and communication. Please feel free to browse
            through the Site. You may download material displayed on the Site
            for your personal use only, provided you also retain all copyright
            and other proprietary notices contained on the material. You may
            not, however, distribute, reproduce, modify, transmit, reuse,
            report, or use the content of the Site for public or commercial
            purposes, including the text, images, audio, and video without TS
            Pool Supply’ express, prior written permission. Your access to and
            use of the Site is also subject to the following terms and
            conditions (“Terms and Conditions”) and all applicable laws. By
            accessing and browsing the Site, you accept, without limitation or
            qualification, the Terms and Conditions.
          </p>
          <p>
            In addition to these Terms and Conditions, please also read our
            Privacy Policy
          </p>
          <Heading2>Terms and Conditions</Heading2>
          <p>
            1. You should assume that everything you see and read on the Site is
            copyrighted unless otherwise noted and may not be reproduced or used
            in any manner except as provided in these Terms and Conditions or in
            the text on the Site without the written permission of TS Pool
            Supply. TS Pool Supply neither warrants nor represents that your use
            of materials displayed on the Site will not infringe rights of third
            parties not owned by or affiliated with TS Pool Supply. You are
            granted limited license only for the purpose of viewing the material
            contained on this Site.
          </p>
          <p>
            2. While TS Pool Supply uses reasonable efforts to include accurate
            and up to date information on the Site, TS Pool Supply makes no
            warranties or representations as to its accuracy. TS Pool Supply
            assumes no liability or responsibility for any errors or omissions
            in the content of this Site.
          </p>
          <p>
            3. You understand and expressly agree that your use of
            TSPoolSupply.com services and browsing on the Site are solely at
            your own risk. Neither TS Pool Supply nor any other party involved
            in creating, producing or delivering the Site is liable for any
            direct, incidental, consequential, indirect, or punitive damages of
            any kind arising out of your access to, or use of, the Site. Without
            limiting the foregoing, everything on the Site is provided to you
            “AS IS”, AS AVAILABLE WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED
            OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
            NON-INFRINGEMENT TO THIS SITE OR THE MATERIALS CONTAINED ON THIS
            SITE. (Check your local laws for any restrictions or limitations
            regarding the exclusion of implied warranties.) TS Pool Supply
            assumes no responsibility for the timeliness, deletion, misdelivery
            or failure to store any content, user communications or
            personalization settings. TS Pool Supply also assumes no
            responsibility, and shall not be liable for, any damages to, or
            viruses that may infect, your computer equipment or other property
            on account of your access to, use of, or browsing on the Site or
            your downloading of any materials, data, text, images, video or
            audio from the Site.
          </p>
          <p>
            4. You agree to indemnify, defend and hold harmless TS Pool Supply,
            its affiliates, officers, directors, employees, consultants and
            agents from any and all third party claims, liability, damages,
            causes of action and/or costs (including, but not limited to,
            attorney fees) arising from your use of our services, your violation
            of our Terms of Services (including, but not limited to, a breach of
            your warranties and representations herein), or your infringement,
            or infringement by any other user of your account, of any
            intellectual property or other right of any person or entity. The
            Terms of Service will insure to the benefit of TS Pool Supply
            successors, assigns, and licensees.
          </p>
          <p>
            These Terms of Service will be governed by and construed in
            accordance with the laws of the State of Arizona, without giving
            effect to its conflicts of laws provision or your actual state or
            country of residence. If for any reason a court of competent
            jurisdiction finds any provision or portion of the Terms of Service
            to be unenforceable, the remainder of the Terms of Service will
            continue in full force and effect.
          </p>
          <p>
            Images of people or places displayed on the Site are either the
            property of, or used with permission by, TS Pool Supply. The use of
            these images by you, or anyone else authorized by you, is prohibited
            unless specifically permitted by these Terms and Conditions or
            specific permission provided elsewhere on the Site. Any unauthorized
            use of the images may violate copyright laws, trademark laws, the
            laws of privacy and publicity and communication regulations and
            statutes.
          </p>
          <p>
            The trademarks, logos and service marks (collectively the
            “Trademarks”) displayed on the Site, including, but not limited to,
            the mark TS Pool Supply®and the TS Pool Supply logo, are registered
            trademarks or trademarks of TS Pool Supply in the United States.
            Nothing contained on the Site should be construed as granting, by
            implication, estoppel, or otherwise, any license or right to use any
            Trademark displayed on the Site without the written permission of TS
            Pool Supply or a third party that may own such Trademark. Your
            misuse of any Trademark displayed on the Site, or any other content
            on the Site, except as provided in these terms and conditions, is
            strictly prohibited. You are also advised that TS Pool Supply will
            aggressively enforce its intellectual property rights to the fullest
            extent of the law.
          </p>
          <p>
            TS Pool Supply has not reviewed the external web sites linked to the
            Site and is not responsible for the content of any off-Site pages or
            any other web sites linked to the Site. By creating a link to a
            third-party web site, TS Pool Supply does not endorse or recommend
            any products or services offered or information contained at that
            web site, nor is TS Pool Supply liable for any failure of products
            or services offered or advertised at those sites. Such third party
            may have a privacy policy different from that of TS Pool Supply and
            the third-party website may provide less security than the Site.
            Your use of links from the Site to reach other sites is at your own
            risk.
          </p>
          <p>
            Any communication or materials you transmit to or through the Site
            by electronic mail or otherwise, including any data, questions,
            comments, suggestions, or the like are, and will be treated as,
            non-confidential and nonproprietary. Except as set forth in our
            Privacy Policy, anything that you transmit or post to or through the
            Site may be used by TS Pool Supply for any purpose, including, but
            not limited to, reproduction, disclosure, transmission, publication,
            broadcast and posting. Furthermore, all information submitted to TS
            Pool Supply through the Site shall be deemed and become the property
            of TS Pool Supply, and TS Pool Supply shall be free to use any
            ideas, concepts, know-how, or techniques sent to or through the Site
            for any purpose whatsoever including, but not limited to,
            developing, manufacturing, and marketing products using such
            information, without compensation or acknowledgment to you.
          </p>
          <p>
            TS Pool Supply may at any time revise these Terms and Conditions by
            updating this posting. You are bound by any such revisions and
            should therefore periodically visit this page to review the then
            current Terms and Conditions. Requests for permission to reproduce
            the copyrighted material contained on the Site should be sent to the
            following address:
          </p>
          <p>
            TS Pool Supply
            <br />
            Attn: Marketing Director
            <br />
            3750 W. Indian School Road
            <br />
            Phoenix, AZ 85019
            <br />
          </p>
          <Heading2>RESPONSIBILITIES</Heading2>
          <p>
            Users alone are responsible for the contents of the messages they
            communicate when using our services and as well as the consequences
            of any such messages. You agree that you will not use our services
            for chain letters, junk mail, “spamming”, or commercial solicitation
            or to engage in illegal activities. You represent and warrant that
            any material you post to or through the Site does not infringe or
            misappropriate any copyright, trademark, patent, publicity, privacy
            or other proprietary right of any person. You further agree not to
            use our services to send any messages or materials that are unlawful
            or that give rise to civil liability, including but not limited to
            defamatory, libelous or infringing materials or materials containing
            computer viruses, Trojan Horses or any other software code designed,
            intended or likely to cause damage to computer hardware, software or
            data of TS Pool Supply or any third party. You hereby consent to TS
            Pool Supply accessing your account and records on a case-by-case
            basis to investigate complaints or other allegations or abuse. TS
            Pool Supply will not disclose the existence or occurrence of such an
            investigation unless required by law. Violation of these terms may
            result in immediate deletion of a user’s account.
          </p>
          <p>
            Information posted to or entered into any message centers, message
            boards, forums or bulletin boards provided on this Site are public
            and not private communications. Although TS Pool Supply reserves the
            right to remove without notice any such communications for any
            reason, TS Pool Supply has no obligation to delete content that you
            may find objectionable or offensive.
          </p>
          <p>
            TS Pool Supply may modify or discontinue any services provided
            through this Site or your account, with or without notice, without
            liability to you, any other user or any third party. TS Pool Supply
            reserves the right to terminate your account if you have provided us
            with false or misleading registration information, interfered with
            other users or the administration of TS Pool Supply services or
            violated these Terms and Conditions.
          </p>
        </Column>
      </Grid>
      <SEO
        title={'Terms and Conditions'}
        description={'Terms and conditions for TS Pool Supply.'}
        openGraph={{
          type: 'website',
          title: 'Terms and conditions',
          description: 'Terms and conditions',
          images: [
            {
              url: '/static_images/ts-pool-supply-og-pool.jpg',
              width: 1280,
              height: 720,
              alt: 'TS Pool Supply',
            },
          ],
        }}
      ></SEO>
    </Container>
  )
}

TermsAndConditions.Layout = Layout
